<template>
  <div class="decision-engine d-flex flex-column align-items-center">
    <div class="decision-engine-wrapper d-flex justify-content-center w-100">
      <div v-if="isOrgAdmin" class="decision-engine-page">
        <router-view @hide-tooltips="hideTooltips()" />
      </div>
      <empty-page v-else type="permission"></empty-page>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { closeAllTooltips } from '@inscribe/signal';
import EmptyPage from '@/shared/components/EmptyPage.vue';

export default {
  components: { EmptyPage },
  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
    }),
  },
  watch: {
    '$route.hash': function () {
      if (this.$route.hash) {
        this.scrollToSection(this.$route.hash);
      } else {
        document.querySelector('.app-wrapper').scrollTo(0, 0);
      }
    },
  },
  mounted() {
    if (this.isOrgAdmin) {
      this.getConfigRulesSchema();
    }
  },
  methods: {
    ...mapActions({
      getConfigRulesSchema: 'getConfigRulesSchema',
    }),
    scrollToSection(selector) {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    },
    hideTooltips() {
      closeAllTooltips();
    },
  },
};
</script>

<style lang="scss" scoped>
.decision-engine {
  height: 100%;

  .decision-engine-wrapper {
    height: 100%;
  }

  :deep(.edit-container) {
    padding-top: 42px;
  }

  :deep(.decision-engine-page-content) {
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 32px;
    padding-bottom: 32px;
    margin: 0 auto;
    width: 1200px;
  }

  :deep(.decision-engine-page-header) {
    padding-left: 32px;
    padding-right: 32px;
    padding-top: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--border-neutral-subtle);
  }

  :deep(.edit-nav) {
    position: absolute;
    top: 0px;
    right: 0;
    left: 240px;
    background: $light-neutral-default;
    z-index: 10;
  }

  :deep(.page-header) {
    border-bottom: 1px solid var(--border-neutral-subtle);
    margin-left: -38px;
    margin-right: -38px;
    padding-left: 0px;
    padding-right: 0px;
    width: 100%;
  }

  &-view,
  &-heading,
  &-page,
  &-menu {
    width: 100%;

    .more-link {
      display: none;
    }

    @include respond-to('large') {
      width: 100%;
      min-width: auto !important;

      .responsive-hide {
        display: none !important;
      }

      .more-link {
        display: list-item;
      }
    }

    :deep(.items-list) {
      $border-radius: 16px;

      border: 1px solid $light-neutral-60;

      .decision-engine-card {
        border-bottom: 1px solid $light-neutral-60;
        width: 100%;
      }

      .decision-engine-card:last-of-type {
        border-bottom: 0;
        border-bottom-left-radius: $border-radius;
        border-bottom-right-radius: $border-radius;
      }

      .decision-engine-card:first-of-type {
        border-top-left-radius: $border-radius;
        border-top-right-radius: $border-radius;
      }
    }
  }
}
</style>
